import React from 'react';

const Image = (props) => {
  const { alt, src, userPage, selectImage, isSelected } = props;

  return (
    <div className="relative">
      <div
        className={`relative cursor-pointer rounded-xl overflow-hidden border-2 transition-all aspect-square ${
          isSelected
            ? 'border-primary ring-2 ring-primary/20'
            : 'border-transparent hover:border-muted-foreground/30'
        }`}
        style={{ background: '#f8fafc' }}
        onClick={selectImage}>
        <img alt={alt} src={src} className="w-full h-full object-cover" />
      </div>
      <p className="text-[10px] text-muted-foreground mt-1 truncate">
        <a
          href={userPage}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:text-primary">
          Visit author
        </a>
      </p>
    </div>
  );
};

export default Image;
